"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getRectangularSpeechBubblePath = void 0;
const constants_1 = require("../../constants");
const utility_paths_1 = require("../utility.paths");
function getRectangularSpeechBubblePath(speechBubbleShape) {
    const width = constants_1.SvgDefaults.viewBoxWidth;
    const fixedBubbleHeight = 90;
    const fixedBubbleWidth = 130;
    const fixedBubblePointerWidth = 20;
    const fixedMaxRadius = 35;
    const bubbleHeight = (fixedBubbleHeight * width) / constants_1.SvgDefaults.viewBoxWidth; // relative to width
    const bubbleWidth = (fixedBubbleWidth * width) / constants_1.SvgDefaults.viewBoxWidth; // relative to width
    const bubblePointer = speechBubbleShape.pointerPosition;
    const bubblePointerHeight = speechBubbleShape.pointerHeight;
    const pointerWidth = (fixedBubblePointerWidth * width) / constants_1.SvgDefaults.viewBoxWidth; // relative to width
    const halfPointerWidth = pointerWidth / 2;
    let pointerHieght = (bubblePointerHeight * ((width - bubbleWidth) / 2)) / 100;
    const lengthTillSecondCorner = bubbleWidth + bubbleHeight;
    const lengthTillThirdCorner = bubbleWidth + lengthTillSecondCorner;
    let pointerPosition = lengthTillThirdCorner - (lengthTillSecondCorner * bubblePointer) / 100;
    const pointerCoordinates = [];
    const pointsToBeExcluded = [];
    pointerHieght = (bubblePointerHeight * Math.min(width - bubbleWidth, width - bubbleHeight)) / 100;
    let startPointX = (width - bubbleWidth) / 2;
    let startPointY = 0;
    // Coordinates for Rectangle
    let coordinates = [];
    coordinates = utility_paths_1.getRectangleCoordinates({ x: startPointX, y: startPointY }, bubbleWidth, bubbleHeight);
    const radiusOption = speechBubbleShape.borderRadius;
    const bubbleRadius = (fixedMaxRadius * width) / constants_1.SvgDefaults.viewBoxWidth;
    const radius = (radiusOption * bubbleRadius) / 100;
    if (pointerHieght) {
        if (pointerPosition <= lengthTillSecondCorner) {
            // Creat Pointer on right vertical side for reactangle
            if (pointerPosition > lengthTillSecondCorner - (halfPointerWidth + radius))
                pointerPosition = lengthTillSecondCorner - (halfPointerWidth + radius); // Restict pointer going out of rectangle
            if (pointerPosition < bubbleWidth + halfPointerWidth + radius)
                pointerPosition = bubbleWidth + halfPointerWidth + radius; // Restict pointer going out of rectangle
            startPointX = 0;
            startPointY = 0;
            // Coordinates for Rectangle
            coordinates = utility_paths_1.getRectangleCoordinates({ x: startPointX, y: startPointY }, bubbleWidth, bubbleHeight);
            pointerCoordinates.push({ x: coordinates[1].x, y: coordinates[1].y + (pointerPosition - bubbleWidth) - pointerWidth / 2 });
            pointerCoordinates.push({ x: coordinates[1].x + pointerHieght, y: coordinates[1].y + (pointerPosition - bubbleWidth) });
            pointerCoordinates.push({ x: coordinates[1].x, y: coordinates[1].y + (pointerPosition - bubbleWidth) + pointerWidth / 2 });
            coordinates.splice(2, 0, ...pointerCoordinates);
            pointsToBeExcluded.push(2, 3, 4);
        }
        else if (pointerPosition <= lengthTillThirdCorner) {
            // Creat Pointer on lower horizontal side for reactangle
            if (pointerPosition > lengthTillThirdCorner - (halfPointerWidth + radius))
                pointerPosition = lengthTillThirdCorner - (halfPointerWidth + radius); // Restict pointer going out of rectangle
            if (pointerPosition < lengthTillSecondCorner + halfPointerWidth + radius)
                pointerPosition = lengthTillSecondCorner + halfPointerWidth + radius; // Restict pointer going out of rectangle
            startPointX = (width - bubbleWidth) / 2;
            startPointY = 0;
            // Coordinates for Rectangle
            coordinates = utility_paths_1.getRectangleCoordinates({ x: startPointX, y: startPointY }, bubbleWidth, bubbleHeight);
            pointerCoordinates.push({
                x: coordinates[2].x - (pointerPosition - lengthTillSecondCorner) + pointerWidth / 2,
                y: coordinates[2].y,
            });
            pointerCoordinates.push({
                x: coordinates[2].x - (pointerPosition - lengthTillSecondCorner),
                y: coordinates[2].y + pointerHieght,
            });
            pointerCoordinates.push({
                x: coordinates[2].x - (pointerPosition - lengthTillSecondCorner) - pointerWidth / 2,
                y: coordinates[2].y,
            });
            coordinates.splice(3, 0, ...pointerCoordinates);
            pointsToBeExcluded.push(3, 4, 5);
        }
    }
    let path = '';
    if (radius) {
        // eslint-disable-next-line @typescript-eslint/no-use-before-define
        path = getRoundedRectangularSpeechBubble(coordinates, radius, pointsToBeExcluded);
    }
    else {
        for (let index = 0; index < coordinates.length; index++) {
            const { x, y } = coordinates[index];
            path = `${path} ${index === 0 ? 'M' : 'L'}${x},${y}`;
        }
    }
    return `${path} Z`;
}
exports.getRectangularSpeechBubblePath = getRectangularSpeechBubblePath;
// Using rounded polygon function with few changes
function getRoundedRectangularSpeechBubble(coordinates, radius, exclude) {
    let path = '';
    if (coordinates.length >= 3) {
        for (let i = 0; i < coordinates.length; i++) {
            if (exclude && exclude.indexOf(i) !== -1) {
                // pointer corners not to be curved
                path += `L${coordinates[i].x},${coordinates[i].y} `;
            }
            else {
                const previousCoordinate = i >= 1 ? coordinates[i - 1] : coordinates[coordinates.length - 1];
                const currentCoordinate = coordinates[i];
                const nextCoordinate = i < coordinates.length - 1 ? coordinates[i + 1] : coordinates[0];
                // Let P(X,Y) is currentCoordinate, P1(X,Y) is previousCoordinate, P2(X,Y) nextCoordinate
                // Let C1(X,Y) and C2(X,Y) be 2 control points to draw Arc at the corners
                // angleBetweenSides = atan(PY - P1Y, PX - P1X) - atan(PY - P2Y, PX - P2X)
                const angleBetweenSides = utility_paths_1.getAngleBetweenSides(previousCoordinate, currentCoordinate, nextCoordinate);
                // segment is distance between current coordinate to control points
                // segment = PC1 = PC2 = radius / |tan(angle / 2)|
                const segment = radius / Math.tan(angleBetweenSides / 2);
                const firstSideLength = Math.sqrt(Math.pow(previousCoordinate.x - currentCoordinate.x, 2) + Math.pow(previousCoordinate.y - currentCoordinate.y, 2));
                // C1X = PX - (PX - P1X) * PC1 / PP1
                // C1Y = PY - (PY - P1Y) * PC1 / PP1
                const firstControlPointX = currentCoordinate.x - ((currentCoordinate.x - previousCoordinate.x) * segment) / firstSideLength;
                const firstControlPointY = currentCoordinate.y - ((currentCoordinate.y - previousCoordinate.y) * segment) / firstSideLength;
                // C2X = PX - (PX - P2X) * PC2 / PP2
                // C2Y = PY - (PY - P2Y) * PC2/ PP2
                const secondSideLength = Math.sqrt(Math.pow(currentCoordinate.x - nextCoordinate.x, 2) + Math.pow(currentCoordinate.y - nextCoordinate.y, 2));
                const secondControlPointX = currentCoordinate.x - ((currentCoordinate.x - nextCoordinate.x) * segment) / secondSideLength;
                const secondControlPointY = currentCoordinate.y - ((currentCoordinate.y - nextCoordinate.y) * segment) / secondSideLength;
                path += `L${firstControlPointX},
                ${firstControlPointY} A${radius} ${radius} 0 0 1${secondControlPointX} ${secondControlPointY} `;
            }
        }
    }
    return path.replace('L', 'M'); // the first command is M
}
//# sourceMappingURL=speechBubble.js.map